export default {
  asc: 'asc',
  desc: 'desc',
}